module.exports = __webpack_public_path__ + "img/sixpackcarrier97.ad7f9846.jpg";